import { render } from "./Login.vue?vue&type=template&id=47255b2a&scoped=true"
import script from "./Login.vue?vue&type=script&lang=ts"
export * from "./Login.vue?vue&type=script&lang=ts"

import "./Login.vue?vue&type=style&index=0&id=47255b2a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-47255b2a"

export default script